import { StaffApiProvider } from '@urbanx/agx.staff.client'
import { AgenciesApiProvider } from '@urbanx/agx.agencies.client'
import { CampaignsApiProvider } from '@urbanx/agx.campaigns.client'
import { DomainApiProvider } from '@urbanx/agx.domain.client'
import { MarketingApiProvider } from '@urbanx/agx.marketing.client'
import { PoolsApiProvider } from '@urbanx/agx.pools.client'
import { RealEstateApiProvider } from '@urbanx/agx.realestate.client'
import { RexApiProvider } from '@urbanx/agx.rex.client'
import { RpDataApiProvider } from '@urbanx/agx.rpdata.client'
import { CampaignFlowApiProvider } from '@urbanx/agx.campaignflow.client'
import { ActivitiesApiProvider } from '@urbanx/agx.activities.client'
import { SupportApiProvider } from '@urbanx/agx.support.client'

const ApiClients = [
    AgenciesApiProvider,
    CampaignsApiProvider,
    StaffApiProvider,
    RpDataApiProvider,
    CampaignFlowApiProvider,
    DomainApiProvider,
    MarketingApiProvider,
    PoolsApiProvider,
    RealEstateApiProvider,
    RexApiProvider,
    ActivitiesApiProvider,
    SupportApiProvider,
  ]

export default ApiClients
